import styled from 'styled-components';
import DefaultButton from '../../components/DefaultButton';

const AuthorsContainer = styled.div``;

const StyledButton = styled(DefaultButton)`
  margin-bottom: 0.5rem;
  padding: 0.4rem !important;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }
`;

export { AuthorsContainer, StyledButton };
